var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanRecords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.6795,
    cy: 74.0156,
    r: 31.6667,
    transform: "rotate(-45 65.6795 74.0156)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.333 67.1201C59.8554 65.6352 60.8864 64.383 62.2435 63.5855C63.6006 62.7879 65.1962 62.4963 66.7476 62.7625C68.2991 63.0286 69.7063 63.8352 70.72 65.0394C71.7337 66.2436 72.2886 67.7678 72.2862 69.3419C72.2862 73.7855 65.6208 76.0074 65.6208 76.0074",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8047 84.3335H65.8211",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.515 111.443L119.463 120.391C121.415 122.344 121.415 125.509 119.463 127.462V127.462C117.51 129.415 114.344 129.415 112.392 127.462L93.5355 108.606C91.5829 106.653 91.5829 103.487 93.5355 101.535V101.535C95.4882 99.5822 98.654 99.5822 100.607 101.535L103.793 104.721",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8906 95.2266L93.9617 102.298",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.59 68.3359L134.015 70.9111",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.579 77.3462L125.004 79.9214",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.59 79.9243L134.015 77.3491",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.579 70.9141L125.004 68.3389",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.0713,
    cy: 132.071,
    r: 3.33333,
    transform: "rotate(45 63.0713 132.071)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.7373,
    cy: 28.7376,
    r: 3.33333,
    transform: "rotate(45 93.7373 28.7376)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanRecords);
export default __webpack_public_path__ + "static/media/scan_records.12ae8f9a.svg";
export { ForwardRef as ReactComponent };